var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"no-data"},[_vm._v(_vm._s(_vm.text || _vm.$t('common.noData')))])}
var staticRenderFns = []

export { render, staticRenderFns }